import React from 'react';
import {FormattedMessage} from 'react-intl';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import {usePaymentRecurringContext} from '../../contexts/PaymentRecurringContext';
import styles from './ButtonSubmitRecurring.module.scss';

const ButtonSubmitRecurring = () => {
  const {loading} = usePaymentRecurringContext();

  return (
    <div className={styles.buttonSubmitContainer}>
      <ButtonAction
        variant={'button'}
        type={'submit'}
        label={(
          <FormattedMessage
            id={'payment-form-submitBtn'}
            defaultMessage={'Create link'}
          />
        )}
        customClassnames={{container: styles.button}}
        disabled={loading}
      />
    </div>
  );
};

export default ButtonSubmitRecurring;
